export const openRouteInNewWindowIfNeeded = (
  route,
  navigate,
  params = {},
  anonUser = false
) => {
  const isElectron = !!window.electron;

  // Construct search parameters
  const searchParams = new URLSearchParams(params).toString();
  const fullRoute = searchParams ? `${route}?${searchParams}` : route;

  if (isElectron && !anonUser) {
    if (window.electron?.openRouteInNewWindow) {
      window.electron.openRouteInNewWindow(fullRoute);
    } else {
      console.error("Electron API not available");
    }
  } else {
    // Web browser behavior
    if (navigate) {
      navigate(fullRoute);
    } else {
      // Fallback for non-React environments
      window.location.hash = fullRoute;
    }
  }
};

export const openCall = async (
  navigate,
  uuid,
  meetingId = null,
  anonUser = false,
  conferenceId = null
) => {
  const canOpen = await canOpenCall();
  if (!canOpen) {
    return false;
  }

  var params = {
    uuid: uuid,
  };

  if (meetingId !== undefined && meetingId !== "") {
    params.meeting_id = meetingId;
  }

  if (conferenceId !== undefined && conferenceId !== null && conferenceId !== "") {
    params.conference_id = conferenceId;
  }

  openRouteInNewWindowIfNeeded("/call", navigate, params, anonUser);

  return true;
};

export const canOpenCall = async () => {
  let secWinds = await numberOfSecondaryWindows();

  return secWinds === 0;
};

export const getWindowDetails = async () => {
  const isElectron = !!window.electron;
  if (!isElectron) {
    return null;
  }

  try {
    let details = await window.electron.getWindowDetails();
    return details;
  } catch (error) {
    console.error("Error checking window status:", error);
    return null;
  }
};

export const closeAllSecondaryWindows = async () => {
  const isElectron = !!window.electron;
  if (!isElectron) {
    return;
  }

  try {
    await window.electron.closeAllSecondaryWindows();
  } catch (err) {
    console.error("Failed to close windows:", err);
  }
};

export const closeIfSecondaryWindow = async () => {
  const isElectron = !!window.electron;
  if (!isElectron) {
    return null;
  }

  try {
    // Check window status
    const { isSecondaryWindow } = await getWindowDetails();

    if (isSecondaryWindow) {
      window.electron.closeCurrentWindow();
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};

const numberOfSecondaryWindows = async () => {
  // Skip in non-Electron environments
  const isElectron = !!window.electron;
  if (!isElectron) {
    return 0;
  }

  try {
    // Check window status
    const secondaryWindowsCount =
      await window.electron.numberOfSecondaryWindows();

    return secondaryWindowsCount;
  } catch (error) {
    return 0;
  }
};
